<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <div class="filter-item">
          <span class="filter-title">Year</span>
          <el-input
            v-model="year"
            clearable
            style="width:100px;margin-right:8px;"
          />
        </div>

        <div class="filter-item">
          <span class="filter-title">Month</span>
          <el-input
            v-model="month"
            clearable
            style="width:100px;margin-right:8px;"
          />
        </div>

        <el-button
          type="primary"
          size="mini"
          @click="handleShow"
        >
          Show
        </el-button>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="records"
      border
      show-summary
    >
      <el-table-column
        label="Date"
        prop="date"
        min-width="100"
      />

      <el-table-column
        label="# Order"
        prop="order_count"
        min-width="60"
      />

      <el-table-column
        label="# Item"
        prop="item_count"
        min-width="60"
      />

      <el-table-column
        label="Gross Sales (USD)"
        prop="sum_gross_sales"
        min-width="120"
      />

      <el-table-column
        label="Net Sales (USD)"
        prop="sum_net_sales"
        min-width="120"
      />

      <el-table-column
        label="Gross Comm. (USD)"
        prop="sum_gross_commission"
        min-width="120"
      />

      <el-table-column
        label="Net Revenue (USD)"
        prop="sum_net_commission"
        min-width="120"
      />
    </el-table>
  </sticky-header-layout>
</template>

<script>
import { getDailySales } from '../../api/reports'

export default {
  name: 'DailySalesReport',
  data() {
    return {
      isLoading: false,
      year: '',
      month: '',
      records: [],
    }
  },
  created() {
    const date = new Date()
    this.year = date.getFullYear()
    this.month = date.getMonth() + 1
  },
  methods: {
    handleShow() {
      this.getRecords(this.year, this.month)
    },
    async getRecords(year, month) {
      this.isLoading = true

      try {
        const response = await getDailySales(this.year, this.month)
        this.records = response.data
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
